






















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Mutation, Action } from "vuex-class";
import { MutationMethod, ActionMethod } from "vuex";

import moment from "moment";
import ReferralListComponent from "@/components/ReferralList.vue";
import { AZNCONNECT_API } from "@/services/aznconnect-api";
import { PagingOptions, GenericReferral } from "@/types/types";
import { ReferralLoadOptions, ReferralModel } from "@/types/aznconnect_api";
import SignalRHub from "@/services/SignalRHub";

@Component({
  components: {
    "referral-list": ReferralListComponent,
  },
})
export default class ListView extends Vue {
  @Prop({ default: null })
  patientNumbers!: string | string[];

  @Prop({ default: null })
  signalRHub!: SignalRHub;

  @Getter("referrals", { namespace: "espoed" })
  referrals!: Array<GenericReferral>;

  showList: boolean = true;
  paging: PagingOptions = new PagingOptions(40, undefined);
  loading: boolean = false;

  @Action("enableMainMenu")
  enableMainMenu!: ActionMethod;

  @Action("loadReferrals", { namespace: "espoed" })
  loadReferralsAction!: ActionMethod;

  openDetails(referral: GenericReferral) {
    this.showList = false;
    this.$router.push({
      name: "readonly-list-detail",
      params: {
        referralId: referral.reference || "",
      },
      query: { pids: this.patientNumbers },
    });
  }

  clickedAmbuFeedback(referral: GenericReferral) {
    this.showList = false;
    this.$router.push({
      name: "readonly-list-detail",
      params: {
        referralId: referral.reference || "",
      },
      query: { pids: this.patientNumbers },
    });
  }

  openedDetails() {
    // This handler makes sure the list is hidden when details are opened
    this.showList = false;
  }

  closeDetails() {
    this.showList = true;
    this.$router.go(-1);
  }

  closedDetails() {
    // This handler makes sure the list is displayed when using the browsers 'back' button
    this.showList = true;
  }

  loadReferrals(newRequest: boolean): boolean {
    const vm = this;

    if (newRequest) {
      this.paging.datetime = undefined;
    }
    this.loading = true;

    let patientNumbers: Array<string> = [];
    patientNumbers = patientNumbers.concat(this.patientNumbers);
    const loadOptions: ReferralLoadOptions = new ReferralLoadOptions(
      "",
      "",
      "",
      "",
      this.paging,
      patientNumbers,
    );

    this.loadReferralsAction(loadOptions)
      .then(response => {
        if (this.referrals) {
          var lastElement = this.referrals.slice(-1).pop();
          if (lastElement && lastElement.messageDateTime) {
            this.paging.datetime = moment(lastElement.messageDateTime).format();
          }
        }
        vm.loading = false;
      })
      .catch(error => {
        vm.loading = false;
        // eslint-disable-next-line no-console
        console.error("Error loading referrals: " + error);
      });

    return false;
  }

  beforeMount(): void {
    this.enableMainMenu(false);
    this.loadReferrals(true);

    this.showList = this.$router.currentRoute.name != "readonly-list-detail";
  }
}
